import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Badge,
  Spinner,
  Button,
  Carousel,
} from "react-bootstrap";

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import { getProductById } from "./api";
import { mapAsplProduct } from "./mapProduct";

const AsplDetailPage = () => {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [carouselIndex, setCarouselIndex] = useState(0);

  useEffect(() => {
    loadProduct();
  }, [id]);

  const loadProduct = async () => {
    setLoading(true);
    try {
      const res = await getProductById(id);
      const info =
        res.data.getProductsInfoResponse?.productInfoList?.productInfo?.[0];

      const mapped = mapAsplProduct(info);
      setProduct(mapped);
    } catch (err) {
      console.error("Failed to load ASPL product", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------------------------------------
     WHATSAPP BUY HANDLER
  --------------------------------------------------- */
  const handleWhatsApp = () => {
    if (!product) return;

    const productUrl = window.location.href;

    const message = `
Hello! I'm interested in this ASPL auto part:

🛠 *${product.name}*
🏷 *Brand:* ${product.brand}
📦 *Category:* ${product.category}

💵 *Price:* ₦${Number(product.priceNGN).toLocaleString("en-NG")}
💲 *USD:* $${product.priceUSD}
🔁 *Exchange Rate:* ₦${product.exchangeRate}/$

📌 *Reference:* ${product.reference}
📌 *OEM:* ${product.oem}
🚚 *Delivery Date:* ${product.deliveryDate}

🔗 Product Link: ${productUrl}
    `.trim();

    const encoded = encodeURIComponent(message);
    const whatsappNumber = "2349098370120"; // your WhatsApp number

    window.open(`https://wa.me/${whatsappNumber}?text=${encoded}`, "_blank");
  };

  /* ---------------------------------------------------
     COPY PRODUCT URL
  --------------------------------------------------- */
  const handleCopyURL = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Product URL copied!");
  };

  if (loading || !product) {
    return (
      <>
        <Navbar />
        <Container className="py-5 text-center">
          <Spinner animation="border" />
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <Container className="py-5">
        <Card className="shadow border-0">
          <Row className="g-0">
            {/* IMAGES */}
            <Col md={6}>
              <Carousel
                activeIndex={carouselIndex}
                onSelect={setCarouselIndex}
                controls={product.photos.length > 1}
                indicators={false}
                interval={null}
              >
                {product.photos.length ? (
                  product.photos.map((img, i) => (
                    <Carousel.Item key={i}>
                      <img
                        src={img}
                        alt=""
                        className="d-block w-100"
                        style={{ maxHeight: 420, objectFit: "contain" }}
                      />
                    </Carousel.Item>
                  ))
                ) : (
                  <Carousel.Item>
                    <div className="bg-light" style={{ height: 420 }} />
                  </Carousel.Item>
                )}
              </Carousel>
            </Col>

            {/* INFO */}
            <Col md={6}>
              <Card.Body>
                <h4>{product.name}</h4>

                <div className="mb-2">
                  <Badge bg="dark" className="me-2">
                    {product.brand}
                  </Badge>
                  <Badge bg={product.stock > 0 ? "success" : "danger"}>
                    {product.stock > 0 ? "In Stock" : "Out of Stock"}
                  </Badge>
                </div>

                <h5 className="text-success">
                  ₦{Number(product.priceNGN).toLocaleString("en-NG")}
                </h5>

                <div className="text-muted small mb-3">
                  USD: ${product.priceUSD}
                  <br />
                  Exchange Rate: ₦{product.exchangeRate}/$
                </div>

                <Row className="small">
                  <Col xs={6}>
                    <strong>Reference:</strong> {product.reference}
                  </Col>
                  <Col xs={6}>
                    <strong>OEM:</strong> {product.oem}
                  </Col>
                  <Col xs={6}>
                    <strong>Tecnum:</strong> {product.tecnum}
                  </Col>
                  <Col xs={6}>
                    <strong>TecID:</strong> {product.tecidd}
                  </Col>
                  <Col xs={12}>
                    <strong>Category:</strong> {product.category}
                  </Col>
                  <Col xs={12}>
                    <strong>Delivery:</strong> {product.deliveryDate}
                  </Col>
                </Row>

                <div className="mt-4 d-flex gap-3 flex-wrap">
                  <Button variant="success" onClick={handleWhatsApp}>
                    Buy on WhatsApp
                  </Button>

                  <Button variant="outline-dark" onClick={handleCopyURL}>
                    Copy Product URL
                  </Button>
                </div>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </Container>

      <Footer />
    </>
  );
};

export default AsplDetailPage;
